<template>
	<div class ="outerBox">
		<!-- <h4 :title="title">{{ title }}</h4> -->
    	<PieChart :chartData="chartData" :optionSet="optionSet"></PieChart>
		<!-- <JsonExcel class="btnExcel" :data="json_data" :fields="json_fields" :worksheet="WorkbookName" :name="fileName">
    		<p>Download Detailed Excel List</p>
		</JsonExcel> -->
	</div>
</template>
<script>
import PieChart from './pieChart.vue';
import JsonExcel from 'vue-json-excel';
export default {
    name: "PieContainer",
    components: { PieChart, JsonExcel },
	props: ["pieData"],
    methods: {
      getRandomColor() {
        let letters = '0123456789ABCDEF';
        let color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
	}
  },
  computed : {
	  title() {
		  return this.pieData.title;
	  },
      chartData() {
        let labels = this.pieData.data.map(_ => _.label);
        let amount = this.pieData.data.map(_ => _.amount);
        let colors = [];
        for(let i = 0; i < this.pieData.data.length; i++) {
            colors[i] = this.getRandomColor();
		}
		
		colors = ['#2da8cb', '#101C31', '#C7C8CA'];
	
        return {
	        name: "PieChart",
			labels: labels,
			title: this.pieData.title,
            datasets: [
            	{
		        	label: this.pieData.title,
                	backgroundColor: colors,
                	data: amount
            	}
            	]
        	};
		},
		json_fields() {
			return {
				[this.pieData.title] : 'title',
				'Count': 'amount'
			}
		},
		json_data() { 
			
			let dataSet = this.pieData.dataExcel.map(_ => ({ title : _.label, amount : _.amount}))
			return dataSet;
		},
		WorkbookName() {
			return this.pieData.title;
		},
		fileName() {
			return this.pieData.title + "_" + ".xls";
		},
		optionSet() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					id: "datalabels-percent",
					datalabels: {
						formatter: (value, ctx) => {
							let sum = 0;
							let dataArr = ctx.chart.data.datasets[0].data;
							dataArr.map(data => {
								sum += data;
							});
							let percentage = (value*100 / sum).toFixed(0)+"%";
							return percentage;
						},
						color: '#FFFFFF',
					}
				}
    		};
		}
  }
}
</script>
<style lang="scss" scoped>

	// .datetimeSelector {
    //     display: inline-flex;
    // }
	.fetchingData {
		font-weight: bold;
	}
	// .outerBox {
	// 	border: 1px solid #2da8cb;
	// }
</style>